<div class="date d-flex w-100 justify-content-center my-3" *ngIf="displayDate">{{displayDate}}</div>
<div class="message-container d-flex"
     [class.message-container-same-author]="sameAuthor"
     [class.is-me]="isMe"
     [class.justify-content-end]="isMe"
>
    <div class="d-flex flex-wrap align-items-end justify-content-end"
         [class.bubble]="!isMe"
         [class.bubble-me]="isMe"
    >
        <p class="message" style="font-size: {{fontSize}}">{{pMessage.text}}</p>
        <p class="time">
            {{displayTime}}
            <fa-icon *ngIf="isMe" [icon]="seenIcon"></fa-icon>
        </p>

    </div>
</div>